import { Grid2, Typography, Button, Box, Chip, Stack, Divider, TableContainer, TableHead, TableRow, TableBody, TableCell, LinearProgress, Table, useMediaQuery } from "@mui/material";
import styles from "./Card.module.css"
import styles1 from "./Dashboard.module.css"
import { LineChart } from '@mui/x-charts/LineChart';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import wvThree from "../assets/svg/wvThree.png"
import wvFour from "../assets/svg/wvFour.png"
import wvFive from "../assets/svg/wvFive.png"
import logo from "../assets/svg/cardlogo.svg"
import moneyBag from "../assets/svg/moneyBag.svg"
import { useNavigate } from "react-router-dom";
import { useScatterChartProps } from "@mui/x-charts/internals";
import { useState } from "react";

export default function Card({setCard , setModal , investmentType , setAmount ,setAmount1, investAmount}) {

    const navigate = useNavigate()
    const screen600px = useMediaQuery("(max-width : 600px)")
    const screen1000px = useMediaQuery("(max-width : 1100px)")
    const [invType , setInvType] = useState(investmentType?.type ? investmentType : JSON.parse(localStorage.getItem("invType")))
    const [stockList , setStockList] = useState([{stockName : "Larsen and Tubro sad 43543" , sector  : "CONSTRUCTION"},{stockName : "Axis Bank", sector  : "Banking"},{stockName : "Tata Motors", sector  : "Automobile"}])
    console.log(investmentType , "cardpage")

    const uData1 = [0, 50, 100, 200, 300];
    const pData1 = [0, 40, 90, 150, 200];
    const xLabels = [
        'April 2020',
        'April 2021',
        'April 2022',
        'April 2023',
        'April 2024',
    ];

    const stocks = [
        { stock: "Financials", percentage: 5 , color : "#007AFF" },
        { stock: "Indusrials", percentage: 9 , color : "#007AFF"},
        { stock: "Information Technology", percentage: 13 , color : "#34C759"},
        { stock: "Utilities", percentage: 17 , color : "#5856D6"},
        { stock: "Consumer Staples", percentage: 2 , color : "#FF2D55"},
        { stock: "Banks", percentage: 22 , color : "#007AFF"},
        { stock: "Private Sector", percentage: 28 , color : "#5856D6"},
    ]

    return (
        <Grid2 className={styles.container}>
            <Button onClick={()=>{
                setCard("")
                navigate("/dashboard")
            }} sx={{color : "white" , alignSelf : "start" , marginLeft : screen1000px ?"30px" :"50px" , marginBottom : "10px"}}><ArrowBackIcon sx={{color : "white" , mr : "5px"}}/>Back</Button>
            {!screen1000px && <Grid2 className={styles.main}> 
                <img src={wvFive} height={69} />
                <Grid2 sx={{ display: "flex", width: "100%" }}>
                    <Grid2 display="flex" width="100%" justifyContent="space-between" alignItems="center" sx={{ marginLeft: screen1000px ? "20px" : "50px" }}>
                        <Grid2 >
                            <Typography className={styles1.energetic}> {invType?.type} </Typography>
                            <Typography className={styles1.highrisk} > {invType?.risk} </Typography>
                        </Grid2>
                        <Grid2 className = {styles.minInvTextGrid}>
                            <Grid2>
                                <Typography className={styles1.fourty}> ₹{invType.type == "Energetic" ? investAmount?.energetic : investAmount?.traditional}</Typography>
                                <Typography className={styles1.mininvest}> Min. Investment  </Typography>
                            </Grid2>
                            <Grid2 ml={ screen1000px ? "50px" : "120px"}>
                            <Typography className={styles1.fourty}>&nbsp;</Typography>
                                
                            </Grid2>

                        </Grid2>
                        <Button className={styles1.investButton} onClick={()=>{
                            setAmount(invType.type == "Energetic" ? investAmount?.energetic : investAmount?.traditional)
                            setAmount1(invType.type == "Energetic" ? investAmount?.energetic : investAmount?.traditional)
                            setModal(true)}
                            }> Invest Now </Button>
                    </Grid2>
                </Grid2>
            </Grid2>}
            {/*Dashboard component reused*/}
            { screen1000px && <Grid2 className={styles1.subGrid} sx={{ display: "flex", flexDirection: "column", width: "90% !important" }} >
                                <Grid2 sx={{ display: "flex", width: "100%" }}>
                                    <img src={wvThree} alt="wvlogo"  className={styles1.cardLogo} />

                                    <Grid2 sx={{ display: "flex", width: "100%" }}>
                                        <Grid2 className={styles1.invTypeTextGrid} >
                                            <Grid2>
                                                <Typography className={styles1.energetic}> {invType?.type} </Typography>
                                                <Typography className={styles1.highrisk} > {invType?.risk} </Typography>
                                            </Grid2>
                                            <Button className={styles1.investButton} onClick={()=>{
                            setAmount(invType.type == "Energetic" ? investAmount?.energetic : investAmount?.traditional)
                            setAmount1(invType.type == "Energetic" ? investAmount?.energetic : investAmount?.traditional)
                            setModal(true)}
                            }> Buy </Button>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>


                                <Grid2 display="flex" sx={{ justifyContent: "space-between", alignContent: "center",alignItems : "end", margin: "3% 0 0 0" }}>
                                    <Grid2 className = {styles1.amountGrid}>
                                        <Typography className={styles1.fourty}> ₹{invType.type == "Energetic" ? investAmount?.energetic : investAmount?.traditional} 
                                            </Typography>
                                        <Typography className={styles1.mininvest}> Min. Investment </Typography>
                                    </Grid2>

                                    <Grid2>
            
                                        
                                    </Grid2>

                                </Grid2>


                            </Grid2>}
                            {/*Dashboard component reused*/}
            <Grid2 className={styles.main1}>
                <Grid2 className = {styles.aboutGrid}>
                    <Typography className={styles.about} >About</Typography>
                    <Typography className={styles.about1}>Explore the potential of our high momentum strategy, which balances performance and volatility for the opportunity of long-term growth and the potential to outperform the index.</Typography>

                    <Typography className={styles.about} sx={{ fontSize: "14px !important", mt: "20px" }} >Holdings Distribution</Typography>
                    <Grid2 sx={{ width: "100%", display: "flex", columnGap: "5px", marginTop: "10px" }}>
                        {[{ title: "10%", color: "#30B0C7" }, { title: "40%", color: "#934FB5" }, { title: "40%", color: "#496E95" }].map(ele => {
                            return (
                                <Chip sx={{ background: ele.color, width: ele.title, height: "7px" }} />
                            )
                        })}
                    </Grid2>

                    <Grid2 className = {styles.sectorGrid} columnGap={2} >
                        {[{ title: "Largecap", color: "#30B0C7" }, { title: "Midcap", color: "#934FB5" }, { title: "Smallcap", color: "#496E95" }].map(ele => {
                            return (
                                <Box>
                                    <Grid2 display="flex" justifyContent="center" alignItems="center">
                                        <Grid2 sx={{ height: "10px", width: "10px", background: ele.color, borderRadius: "100%" }} ></Grid2>
                                        <Typography className={styles.capText} > {ele?.title}</Typography>
                                    </Grid2>
                                    <Typography ml="15px !important" className={styles.capPer} >10%</Typography>
                                </Box>
                            )
                        })}
                    </Grid2>
                </Grid2>
                <Grid2 className = {styles.chart}>
                    <Typography className={styles.about} ml="20px">Performance Highlights</Typography>

                    <LineChart
                        height={250}
                        series={[
                            { curve: "linear", data: pData1, color: "#AD41F0", showMark: false },
                            { curve: "linear", data: uData1, color: "#34C759", showMark: false },
                        ]}
                        xAxis={[{ scaleType: 'point', data: xLabels }]}
                    />
                </Grid2>
            </Grid2>
            <Grid2 sx={{backgroundColor : "#ffffff" , width : "90%"}}>
            <Grid2 className = {styles.chart1}>
                    <Typography className={styles.about} ml="30px" marginTop="20px">Performance Highlights</Typography>

                    <LineChart
                        height={250}
                        series={[
                            { curve: "linear", data: pData1, color: "#AD41F0", showMark: false },
                            { curve: "linear", data: uData1, color: "#34C759", showMark: false },
                        ]}
                        xAxis={[{ scaleType: 'point', data: xLabels }]}
                    />
                </Grid2>
            </Grid2>
            <Grid2 className={styles.main1}>
            <Grid2 className = {styles.stockWeightsGrid1} mb="30px">
                    <Typography className={styles.about} m="10px 10px 10px 0px" >Stocks & Weights</Typography>
                    <TableContainer sx={{ width: "100% !important" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ padding: "7px", color: "#7C7C7C", fontFamily: "Inter600", width: "150px" }}>Sector</TableCell>
                                    <TableCell sx={{ padding: "7px", color: "#7C7C7C", fontFamily: "Inter600" }}>Allocation</TableCell>
                                    <TableCell sx={{ padding: "7px 0px 7px 0px", color: "#7C7C7C", fontFamily: "Inter600", width: "300px" }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {stocks.map(ele => {
                                    return (
                                        <TableRow>
                                            <TableCell sx={{ padding: "7px" }}>{ele.stock}</TableCell>
                                            <TableCell sx={{ padding: "7px" }}>{ele.percentage}% </TableCell>
                                            <TableCell><LinearProgress sx={{
                                                '& .MuiLinearProgress-bar': {
                                                    backgroundColor: ele.color
                                                }
                                            }} variant="determinate" value={ele.percentage} /></TableCell>
                                        </TableRow>
                                    )
                                })}

                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid2>
            </Grid2>
            <Grid2 className={styles.main2}>
                <Grid2 className = {styles.stockListingGrid} >
                    {stockList.map((ele,i) => {
                        return (
                            <>
                                <Grid2 display="flex" mt="20px" width="100%">
                                    <Grid2 minWidth={screen600px ? "100%" : "300px"} >
                                        <Typography className={styles.about} >{ele.stockName}</Typography>
                                        <Typography className={styles.price} >₹ 5,024</Typography>
                                        <Typography className={styles.time}>7 Jun, 3:30 pm IST</Typography>
                                        <Stack direction="row" mt={1} spacing={ screen600px ? 1 : 2}>
                                            <Chip className={styles.chip}   size="small" label="LARGE CAP" />
                                            <Chip className={styles.chip} label={ele?.sector} size="small" />
                                            <Chip className={styles.chip} label="MODERATE RISK" size="small" />
                                        </Stack>
                                    </Grid2 >
                                    <Grid2 className = {styles.stockGrid}>
                                        <Grid2 className = {styles.stockPriceGrid}>
                                            <img src={moneyBag} style={{ margin: "2px 10px 0px 0px" }} />
                                            <Typography className={styles.buyAt} mr="10px">Buy at : 1000000</Typography>
                                            <Typography className={styles.buyAt} >Target : 1000000</Typography>
                                        </Grid2>
                                        <Grid2 className = {styles.stockPriceGrid1}>
                                            <img src={moneyBag} style={{ margin: "10px 10px 0px 0px" , height : "25px" }} />
                                            <Grid2>
                                            <Typography className={styles.buyAt} ml={0}>Buy at : 1000000</Typography>
                                            <Typography className={styles.buyAt} ml={0}>Target : 1000000</Typography>
                                            </Grid2>
                                        </Grid2>
                                        <Typography ml="20px" >No of Shares : 2</Typography>
                                       
                                    </Grid2>
                                </Grid2>
                                <Grid2 className = {styles.stockPriceGrid3}>
                                            <img src={moneyBag} style={{ margin: "2px 10px 0px 0px" }} />
                                            <Typography className={styles.buyAt} mr="10px">Buy at : 1000000</Typography>
                                            <Typography className={styles.buyAt} >Target : 1000000</Typography>
                                            
                                        </Grid2>
                                        <Typography ml="28px" display={screen600px ? "inline" : "none"} >No of Shares : 2</Typography>
                                <Divider sx={{ background: "#999999", marginTop: "20px"}} />
                            </>
                        )
                    })}
                </Grid2>
                
            <Grid2 className = {styles.stockWeightsGrid}>
                    <Typography className={styles.about} m="60px 10px 10px 0px" >Stocks & Weights</Typography>
                    <TableContainer sx={{ width: "100% !important" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ padding: "7px", color: "#7C7C7C", fontFamily: "Inter600", width: "150px" }}>Sector</TableCell>
                                    <TableCell sx={{ padding: "7px", color: "#7C7C7C", fontFamily: "Inter600" }}>Allocation</TableCell>
                                    <TableCell sx={{ padding: "7px 0px 7px 0px", color: "#7C7C7C", fontFamily: "Inter600", width: "300px" }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {stocks.map(ele => {
                                    return (
                                        <TableRow>
                                            <TableCell sx={{ padding: "7px" }}>{ele.stock}</TableCell>
                                            <TableCell sx={{ padding: "7px" }}>{ele.percentage}% </TableCell>
                                            <TableCell><LinearProgress sx={{
                                                '& .MuiLinearProgress-bar': {
                                                    backgroundColor: ele.color
                                                }
                                            }} variant="determinate" value={ele.percentage} /></TableCell>
                                        </TableRow>
                                    )
                                })}

                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid2>
            </Grid2>
            </Grid2>
    )
}